import { isEmpty } from '../../../utils'

export const jumpProps = {
  value: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  },
  row: {
    type: Object
  },
  showTooltip: {
    type: Boolean,
    default: true
  },
  tenantType: {
    type: String,
    default: ''
  },
  linkObjectApiName: {
    type: String,
    default: ''
  },
  layoutApiName: {
    type: String,
    default: ''
  },
  linkOperationApiName: {
    type: String,
    default: ''
  }
}

export function initValue (value) {
  return isEmpty(value) ? '-' : value
}